module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FormSignup', {
    key: "signup",
    staticClass: "form__sign_up",
    attrs: {
      "validateBeforeSubmit": true
    },
    on: {
      "submit": _vm.signUp
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fa72f0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/Register.vue
// module id = 470e3bb7b4a7cc35a1a2
// module chunks = 89